import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { MetricCellRow } from './MetricCellRow';
import { getRangesWithDefault } from './metricRange';
import { AddMetricSelect } from './AddMetricSelect';
import { useJourneyFilters } from '../../../../useJourneyFilters';
import { Box } from '@mui/material';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

const MetricsCell: FC<WidgetProps> = ({ activityId, activityName, widget: { contentMetrics } }) => {
	const [filters] = useJourneyFilters();
	const [showAddMetric, setShowAddMetric] = useState(false);
	const {
		compareRange: { start: compareStart, end: compareEnd },
		targetRange: { start: targetStart, end: targetEnd },
	} = getRangesWithDefault(filters.date);

	return (
		<WidgetCell
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.metrics.type}
			onMouseEnter={() => setShowAddMetric(true)}
			onMouseLeave={() => setShowAddMetric(false)}
		>
			{contentMetrics
				.sort((a, b) => (a.metric?.name != null && b.metric?.name != null ? a.metric.name.localeCompare(b.metric.name) : 0))
				.map((contentMetric) => (
					<MetricCellRow
						key={contentMetric.id}
						activityId={activityId}
						contentMetric={contentMetric}
						unitSign={contentMetric.metric?.unitSign ?? contentMetric.metric?.dataSet?.metricTemplate?.unitSign ?? null}
						compareStart={compareStart}
						compareEnd={compareEnd}
						targetStart={targetStart}
						targetEnd={targetEnd}
					/>
				))}

			<Box sx={{ mt: 1.5, opacity: showAddMetric ? 1 : 0 }}>
				<AddMetricSelect activityId={activityId} contentMetricIds={contentMetrics.map(({ id }) => id)} />
			</Box>
		</WidgetCell>
	);
};

export { MetricsCell };
